















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    tooltipText: {
      type: String,
      required: true
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'mdi-alert'
    }
  }
});
